declare namespace $ {

	type $bog_fragile_demo_outer_widget1__city_bog_fragile_demo_outer_page1_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_outer_widget1['city'] >
	>
	export class $bog_fragile_demo_outer_page1 extends $mol_view {
		Weather( ): $bog_fragile_demo_outer_widget1
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page1.view.tree.d.ts.map